<div class="placeholder-popup">
  <div class="popup-header-container">
    <div class="popup-header">
      <h2>
        {{
          channelJsons[activeChannel].channelType === "Recipient ID"
            ? "Select Recipient/Mobile Number"
            : "Map Placeholder"
        }}
      </h2>
      <span
        class="close-icon"
        (click)="dialogRef.close()"
        (keydown)="$event.preventDefault()"
      >
        &times;
      </span>
    </div>
    <!-- Custom Channel Stepper -->
    <ng-container>
      <div class="channel-stepper">
        <div
          *ngFor="let ch of channelJsons; let i = index"
          class="channel-step"
          [ngClass]="{
            completed: channelComplete(i),
            active: activeChannel === i,
            touched:
              isChannelTouched(i) && !channelComplete(i) && activeChannel !== i,
            pending:
              !channelComplete(i) && !isChannelTouched(i) && i > activeChannel,
            clickable: isChannelClickable(i),
          }"
          [style.cursor]="isChannelClickable(i) ? 'pointer' : 'not-allowed'"
          (click)="onChannelSelect(i)"
          (keydown)="$event.preventDefault()"
        >
          <div class="step-circle">
            <ng-container *ngIf="channelComplete(i); else showNumber">
              <i class="pi pi-check"></i>
            </ng-container>
            <ng-template #showNumber>{{ i + 1 }}</ng-template>
          </div>
          <div class="step-label">{{ ch.channelType }}</div>
          <div *ngIf="i < channelJsons.length - 1" class="step-bar"></div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Split Screen -->
  <div
    class="split-screen-container"
    [class.recipient-mode]="
      channelJsons[activeChannel].channelType === 'Recipient ID'
    "
  >
    <div class="form-panel">
      <div class="section-container">
        <ng-container
          *ngIf="
            channelJsons[activeChannel].channelType === 'Recipient ID';
            else noRecipient
          "
        >
          <div [formGroup]="channelForms[activeChannel]">
            <div
              class="card-container mb-2"
              *ngFor="
                let sec of channelJsons[activeChannel].sections;
                let i = index
              "
            >
              <div class="head">{{ sec.header }}</div>
              <div class="card-list">
                <div class="placeholders">
                  <ng-container
                    *ngIf="sec.sectionKey === 'pushRecipient'; else dropdown"
                  >
                    <p>Select One for Push Notification</p>
                    <ng-container *ngFor="let ph of sec.placeholders">
                      <div
                        class="d-flex gap-2 align-items-center w-100 mt-2 mb-2"
                      >
                        <p-radioButton
                          [name]="'pushRecipient_' + activeChannel"
                          [value]="ph.key"
                          [(ngModel)]="selectedPushOption"
                          [ngModelOptions]="{ standalone: true }"
                          [inputId]="ph.controlKey + '_radio'"
                          (onClick)="
                            channelForms[activeChannel]
                              .get(ph.controlKey)
                              ?.setValue(null)
                          "
                        ></p-radioButton>
                        <label [for]="ph.controlKey + '_radio'">{{
                          ph.label
                        }}</label>
                      </div>
                      <ng-container
                        *ngIf="selectedPushOption === ph.key && ph.needsInput"
                      >
                        <p-dropdown
                          [options]="
                            channelJsons[activeChannel].options | arrayToOptions
                          "
                          optionLabel="label"
                          optionValue="value"
                          appendTo="body"
                          [formControlName]="ph.controlKey"
                          placeholder="Select Value"
                        >
                        </p-dropdown>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #dropdown>
                    <div
                      class="placeholder-item"
                      *ngFor="let ph of sec.placeholders"
                    >
                      <label [for]="ph.key"
                        >{{ ph.label }} <span class="required">*</span></label
                      >
                      <p-dropdown
                        inputId="{{ ph.key }}"
                        [options]="
                          channelJsons[activeChannel].options | arrayToOptions
                        "
                        optionLabel="label"
                        optionValue="value"
                        [formControlName]="ph.controlKey"
                        placeholder="Select {{ ph.label }}"
                        (onClick)="
                          setActiveFocusPlaceholder(ph.key);
                          updateHighlightedContent(activeChannel)
                        "
                        (onChange)="
                          setActiveFocusPlaceholder(null);
                          updateHighlightedContent(activeChannel)
                        "
                        (onHide)="
                          setActiveFocusPlaceholder(null);
                          updateHighlightedContent(activeChannel)
                        "
                        [filter]="true"
                        appendTo="body"
                        dropdownIcon="pi pi-chevron-down"
                      >
                        <ng-template pTemplate="item" let-opt>
                          <div class="option-item">{{ opt.label }}</div>
                        </ng-template>
                      </p-dropdown>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <div class="nav-buttons">
              <p-button
                label="Back"
                styleClass="p-button-outlined p-button-rounded"
                (click)="onPreviousChannel($event)"
                (keydown)="$event.preventDefault()"
              ></p-button>

              <p-button
                label="Submit"
                styleClass="p-button-filled p-button-rounded"
                (click)="onFinish($event)"
                [disabled]="!isRecipientFormValid()"
                [ngClass]="{
                  'disable-btn': !isRecipientFormValid(),
                }"
                (keydown)="$event.preventDefault()"
              ></p-button>
            </div>
          </div>
        </ng-container>
        <ng-template #noRecipient>
          <div class="section-stepper">
            <div
              *ngFor="
                let sec of channelJsons[activeChannel].sections;
                let j = index
              "
              class="section-step"
              [ngClass]="{
                completed: isSectionComplete(activeChannel, j),
                active: isSectionActive(activeChannel, j),
                pending:
                  !isSectionComplete(activeChannel, j) && j > activeSection,
              }"
              (click)="onSectionSelect(j)"
              (keydown)="$event.preventDefault()"
            >
              <div class="section-step-header">
                <div class="step-circle-small">
                  <ng-container
                    *ngIf="isSectionComplete(activeChannel, j); else secNum"
                    ><i class="pi pi-check"></i
                  ></ng-container>
                  <ng-template #secNum
                    ><span> {{ j + 1 }}</span></ng-template
                  >
                </div>
                <div class="step-label-small">{{ sec.header }}</div>
              </div>
              <!-- Section Content -->
              <div class="section-content-container">
                <div
                  *ngIf="j < channelJsons[activeChannel].sections.length - 1"
                  class="step-bar-small"
                ></div>
                <div
                  class="section-content"
                  [formGroup]="channelForms[activeChannel]"
                  *ngIf="isSectionActive(activeChannel, j)"
                  [ngClass]="{
                    'ml-40':
                      j === channelJsons[activeChannel].sections.length - 1,
                  }"
                >
                  <ng-container
                    *ngIf="
                      activeSectionJson.sectionKey ===
                      placeholderConstant.ADDITIONAL_PARAM
                    "
                  >
                    <div
                      class="d-flex gap-2 mb-1 mt-1 additional-param-container"
                    >
                      <span><p>Do you want to map unique parameters?</p></span>
                      <p-inputSwitch
                        [(ngModel)]="activeSectionJson.isVisibleOption"
                        [ngModelOptions]="{ standalone: true }"
                        (onChange)="onChangeToggle()"
                      >
                      </p-inputSwitch>
                    </div>

                    <ng-container *ngIf="activeSectionJson.isVisibleOption">
                      <div class="col-md-12 key-value-container">
                        <label for="selectKeyValue">Select Key Value</label>
                        <p-dropdown
                          inputId="selectKeyValue"
                          [options]="activeSectionJson.labelOptions || []"
                          optionLabel="label"
                          appendTo="body"
                          [(ngModel)]="activeSectionJson.selectedKey"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="onKeyValueChange($event)"
                          placeholder="Select Key Value"
                        >
                          <ng-template pTemplate="item" let-option>
                            <div>{{ option.label }}</div>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="activeSectionJson.selectedKey">
                      <div class="placeholder-item mt-3">
                        <label for="{{ activeSectionJson.selectedKey.key }}">{{
                          "Map " + activeSectionJson.selectedKey.label
                        }}</label>
                        <p-dropdown
                          inputId="{{ activeSectionJson.selectedKey.key }}"
                          [options]="
                            channelJsons[activeChannel].options | arrayToOptions
                          "
                          optionLabel="label"
                          optionValue="value"
                          [formControl]="
                            getFormControl(activeSectionJson.selectedKey.key)
                          "
                          placeholder="Mapped Value"
                          appendTo="body"
                          (onClick)="
                            setActiveFocusPlaceholder(
                              activeSectionJson.selectedKey?.key || null
                            );
                            updateHighlightedContent(activeChannel)
                          "
                          (onChange)="
                            setActiveFocusPlaceholder(null);
                            updateHighlightedContent(activeChannel)
                          "
                          (onHide)="
                            setActiveFocusPlaceholder(null);
                            updateHighlightedContent(activeChannel)
                          "
                        >
                          <ng-template pTemplate="item" let-opt>
                            <div class="option-item">{{ opt.label }}</div>
                          </ng-template>
                        </p-dropdown>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      activeSectionJson.sectionKey !==
                        placeholderConstant.CARD &&
                      activeSectionJson.sectionKey !==
                        placeholderConstant.ADDITIONAL_PARAM
                    "
                  >
                    <div class="section-header">
                      <h6
                        *ngIf="
                          channelJsons[activeChannel].sections[activeSection]
                            .subHeading
                        "
                      >
                        {{
                          channelJsons[activeChannel].sections[activeSection]
                            .subHeading
                        }}
                      </h6>
                    </div>

                    <ng-container
                      *ngIf="
                        activeSectionJson.isVisibleOption &&
                        activeSectionJson.sectionKey ===
                          placeholderConstant.ADDITIONAL_PARAM
                      "
                    >
                      <div class="placeholders">
                        <div
                          *ngFor="let ph of activeSectionJson.placeholders"
                          class="placeholder-item"
                        >
                          <label for="{{ ph.key }}">{{ ph.label }}</label>
                          <p-dropdown
                            inputId="{{ ph.key }}"
                            [options]="
                              channelJsons[activeChannel].options
                                | arrayToOptions
                            "
                            optionLabel="label"
                            optionValue="value"
                            [formControlName]="ph.controlKey"
                            placeholder="Select {{ ph.label }}"
                            [filter]="true"
                            appendTo="body"
                            dropdownIcon="pi pi-chevron-down"
                          >
                            <ng-template pTemplate="item" let-opt>
                              <div class="option-item">{{ opt.label }}</div>
                            </ng-template>
                          </p-dropdown>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container
                      *ngIf="
                        !activeSectionJson.isVisibleOption ||
                        activeSectionJson.sectionKey !==
                          placeholderConstant.ADDITIONAL_PARAM
                      "
                    >
                      <div class="placeholders">
                        <ng-container
                          *ngFor="
                            let ph of channelJsons[activeChannel].sections[
                              activeSection
                            ].placeholders
                          "
                        >
                          <div class="placeholder-item">
                            <label for="{{ ph.key }}"
                              >{{ ph.label }}
                              <span
                                class="required"
                                *ngIf="
                                  !channelForms[activeChannel].get(ph.key)
                                    ?.value
                                "
                                >*</span
                              ></label
                            >

                            <p-dropdown
                              inputId="{{ ph.key }}"
                              [options]="
                                channelJsons[activeChannel].options
                                  | arrayToOptions
                              "
                              optionLabel="label"
                              optionValue="value"
                              [formControlName]="ph.controlKey"
                              placeholder="Select {{ ph.label }}"
                              (onClick)="
                                setActiveFocusPlaceholder(ph.key);
                                updateHighlightedContent(activeChannel)
                              "
                              (onChange)="
                                setActiveFocusPlaceholder(null);
                                updateHighlightedContent(activeChannel)
                              "
                              (onHide)="
                                setActiveFocusPlaceholder(null);
                                updateHighlightedContent(activeChannel)
                              "
                              [filter]="true"
                              appendTo="body"
                              dropdownIcon="pi pi-chevron-down"
                            >
                              <ng-template pTemplate="item" let-opt>
                                <div class="option-item">{{ opt.label }}</div>
                              </ng-template>
                            </p-dropdown>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-container>

                  <ng-container
                    *ngIf="
                      activeSectionJson.sectionKey ===
                        placeholderConstant.CARD &&
                      activeSectionJson.sectionKey !==
                        placeholderConstant.ADDITIONAL_PARAM
                    "
                  >
                    <div
                      *ngFor="let card of sec.cards; let i = index"
                      class="card-container mb-2"
                    >
                      <div class="head">
                        <b>Card {{ +card.sequence + 1 }}</b>
                        <span
                          (click)="collapseCard(i)"
                          (keydown)="$event.preventDefault()"
                          ><img
                            *ngIf="!card.isVisible"
                            src="assets/svg/common/primary-down-arrow.svg"
                            alt="Arrow down" /><img
                            *ngIf="card.isVisible"
                            src="assets/svg/common/primary-up-arrow.svg"
                            alt="Arrow up"
                        /></span>
                      </div>
                      <div class="card-list" *ngIf="card.isVisible">
                        <ng-container *ngFor="let group of card.groups">
                          <ng-container *ngIf="group.placeholders.length > 0">
                            <hr *ngIf="group !== card.groups[0]" />
                            <div class="form-label">
                              <b>{{ group.title }}</b>
                            </div>
                            <div class="placeholders">
                              <ng-container
                                *ngFor="let ph of group.placeholders"
                              >
                                <div class="placeholder-item">
                                  <label for="{{ ph.key }}"
                                    >{{ ph.label }}
                                    <span
                                      class="required"
                                      *ngIf="
                                        !channelForms[activeChannel].get(ph.key)
                                          ?.value
                                      "
                                      >*</span
                                    ></label
                                  >

                                  <p-dropdown
                                    inputId="{{ ph.key }}"
                                    [options]="
                                      channelJsons[activeChannel].options
                                        | arrayToOptions
                                    "
                                    optionLabel="label"
                                    optionValue="value"
                                    [formControl]="
                                      getFormControl(ph.controlKey)
                                    "
                                    placeholder="Select {{ ph.label }}"
                                    (onClick)="
                                      setActiveFocusPlaceholder(ph.key);
                                      updateHighlightedContent(activeChannel)
                                    "
                                    (onChange)="
                                      setActiveFocusPlaceholder(null);
                                      updateHighlightedContent(activeChannel)
                                    "
                                    (onHide)="
                                      setActiveFocusPlaceholder(null);
                                      updateHighlightedContent(activeChannel)
                                    "
                                    [filter]="true"
                                    appendTo="body"
                                    dropdownIcon="pi pi-chevron-down"
                                  >
                                    <ng-template pTemplate="item" let-opt>
                                      <div class="option-item">
                                        {{ opt.label }}
                                      </div>
                                    </ng-template>
                                  </p-dropdown>
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>

                  <!-- Navigation Buttons -->
                  <div class="nav-buttons">
                    <p-button
                      *ngIf="activeChannel !== 0 || activeSection !== 0"
                      label="Back"
                      styleClass="p-button-outlined p-button-rounded"
                      (click)="onPrevSection($event)"
                      (keydown)="$event.preventDefault()"
                    ></p-button>

                    <p-button
                      *ngIf="
                        !(
                          activeChannel === channelJsons.length - 1 &&
                          activeSection ===
                            channelJsons[activeChannel].sections.length - 1
                        )
                      "
                      label="Next"
                      styleClass="p-button-filled p-button-rounded"
                      (click)="onNextSection($event)"
                      [ngClass]="{
                        'disable-btn': !isSectionValid(
                          activeChannel,
                          activeSection
                        ),
                      }"
                      [disabled]="!isSectionValid(activeChannel, activeSection)"
                      (keydown)="$event.preventDefault()"
                      tabindex="0"
                    ></p-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div
      class="preview-panel"
      *ngIf="channelJsons[activeChannel].channelType !== 'Recipient ID'"
    >
      <span class="preview-panel-heading">Template Preview</span>
      <ng-container
        *ngIf="channelJsons[activeChannel]?.templateCode as tplCode"
      >
        <!-- Loading State -->
        <div class="preview-loading" *ngIf="previewApiLoadingMap[tplCode]">
          <i
            class="pi pi-spin pi-spinner"
            style="font-size: 2rem; color: #3f51b5"
          ></i>
          <span>Loading preview...</span>
        </div>

        <!-- Error State -->
        <div
          class="preview-api-error"
          *ngIf="previewApiErrorMap[tplCode] as err"
        >
          <div class="preview-api-error-title">
            <i class="pi pi-exclamation-triangle"></i>
            Error loading template preview
          </div>
          <div class="preview-api-error-message">{{ err }}</div>
          <div class="preview-api-error-actions">
            <p-button
              label="Retry"
              styleClass="p-button-filled p-button-rounded p-button-sm"
              [disabled]="previewApiLoadingMap[tplCode]"
              (click)="
                fetchTemplateData(activePreviewChannel, tplCode, activeChannel)
              "
              (keydown)="$event.preventDefault()"
            ></p-button>
          </div>
        </div>

        <!-- Form Preview (when form section is active) -->
        <ng-container
          *ngIf="isFormSectionActive && activeFormCode; else templatePreview"
        >
          <div class="form-preview-container">
            <app-preview-form
              [formCode]="activeFormCode"
              [isPublishView]="false"
            ></app-preview-form>
          </div>
        </ng-container>

        <!-- Template Preview -->
        <ng-template #templatePreview>
          <app-unified-template-preview
            *ngIf="
              !previewApiErrorMap[tplCode] && !previewApiLoadingMap[tplCode]
            "
            [channel]="normalizeChannelToPreviewCase(activePreviewChannel)"
            [templateData]="templateDataMap[tplCode]"
            [highlightedContent]="highlightedContentMap[tplCode] || ''"
            [whatsAppCarouselHighlightedContents]="
              whatsAppCarouselHighlightedContentMap[tplCode] || []
            "
            [rcsCarouselHighlightedContents]="
              rcsCarouselHighlightedContentMap[tplCode] || []
            "
            [activeFocusPlaceholder]="activeFocusPlaceholder"
          ></app-unified-template-preview>
        </ng-template>
      </ng-container>
    </div>
  </div>
</div>
